export default "__VITE_ASSET__04b0d1d8__"